<template>
  <form @submit.prevent="handleSubmit()" class="regular-form">

    <!-- Name -->
    <address-name-field
      v-model="$attrs.address.name"
      :error="$attrs.errors.address.name"
    />

    <!-- District -->
    <district-field
      v-model="$attrs.address.district"
      :error="$attrs.errors.address.district"
      v-show="!(formType == 'add' && $attrs.address.district)"
    />

    <div class="form-group text-center">
      <input class="btn btn-primary btn-lg" type="submit" :value="submitLabel">
    </div>
  </form>
</template>

<script>
import addressNameField from '@/components/forms/address/fields/AddressName'
import districtField from '@/components/forms/address/fields/District'

export default {
  name: 'address-blank-form',
  inheritAttrs: false,
  props: {
    submitLabel: {
      type: String,
      default: 'Submit'
    },
    formType: {
      type: String,
      required: true
    }
  },
  components: {
    addressNameField,
    districtField
  },
  methods: {
    handleSubmit () {
      this.$emit('submit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// AddressBlankForm.vue?7080fae4